module.exports = __webpack_public_path__ + "static/pyramids_image-b464222a9e7b54c1b88ae171f58b4c9a.png";